import { render, staticRenderFns } from "./UserBioEdit.vue?vue&type=template&id=1328cc6a"
import script from "./UserBioEdit.vue?vue&type=script&lang=js"
export * from "./UserBioEdit.vue?vue&type=script&lang=js"
import style0 from "./UserBioEdit.vue?vue&type=style&index=0&id=1328cc6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports